var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st-Modal_Container"},[(_vm.closeBtn)?_c('div',{staticClass:"st-Modal_CloseBtn",on:{"click":_vm.closeModal}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sw-Scrollbar st-Modal_Contents"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }